// src/components/common/brand.jsx

export const BRAND = {
    name: "Pashora",
    tagline: "",
};